module.exports = "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI5LjAxIDI5LjAxIj4NCiAgPGNpcmNsZSBjeD0iMTQuNTEiIGN5PSIxNC41MSIgcj0iMTMuMDMiIHN0cm9rZT0iIzEwYTQxZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIuNSIgZmlsbD0ibm9uZSIvPg0KICA8cGF0aCBmaWxsPSIjZmZmIiBzdHJva2U9IiMxMGE0MWQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyLjUiIGQ9Ik0xMC4wMiAxNS4wM2wzLjcgNC4yMiA1LjI3LTkuNDkiLz4NCjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_sent.svg
// module id = 1720
// module chunks = 4